import { profile, axiosConfig } from 'api';

import {
  PaymentExceptionProduct,
  PaymentExceptionProvider,
  PaymentExceptionProviderResponse,
  PaymentExceptionRequest,
  PaymentExceptionResponse,
} from 'models/paymentException';
import { Response } from 'models/response';

export const getAllPaymentExceptions = async (companyId: string): Promise<PaymentExceptionResponse[]> => {
  try {
    const response = await profile.get<Response<PaymentExceptionResponse[]>>(
      '/PaymentException/GetAll',
      axiosConfig,
    );
    return response.data.data || [];
  } catch (error) {
    return Promise.reject(error);
  }
};

export const getPaymentExceptionProviders = async (
  product: PaymentExceptionProduct,
): Promise<PaymentExceptionProvider[]> => {
  try {
    const response = await profile.get<Response<PaymentExceptionProviderResponse>>(
      `/PaymentException/GetProviders/${product}`,
      axiosConfig,
    );

    const credentials = response.data.data?.credentials ?? [];

    return credentials.map((c) => ({
      code: c,
      name: c,
    }));
  } catch (error) {
    return Promise.reject(error);
  }
};

export const createPaymentException = async (data: PaymentExceptionRequest): Promise<Response<PaymentExceptionResponse>> => {
  try {
    const response = await profile.post<Response<PaymentExceptionResponse>>('/PaymentException', data, axiosConfig);
    return response.data;
  } catch (error) {
    return Promise.reject(error);
  }
};

export const updatePaymentException = async (
  id: string,
  data: PaymentExceptionRequest,
): Promise<Response<PaymentExceptionResponse>> => {
  try {
    const response = await profile.put<Response<PaymentExceptionResponse>>(
      `/PaymentException/${id}`,
      data,
      axiosConfig,
    );
    return response.data;
  } catch (error) {
    return Promise.reject(error);
  }
};

export const deletePaymentException = async (id: string): Promise<Response<any>> => {
  try {
    const response = await profile.delete<Response<any>>(`/PaymentException/${id}`, axiosConfig);
    return response.data;
  } catch (error) {
    return Promise.reject(error);
  }
};
